<template>
  <!-- 运单库存 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button v-if="hasPermiss('aaaaa')" class="glo_btnItems" @click="ruKuConfirm()">入库确认</el-button>
        <el-button class="glo_btnItems glo_bgcMainColor" @click="wtl_outStockSure()">出库确认</el-button>
        <el-button class="glo_btnItems" @click="luRuFeiYong()">装卸费录入</el-button>
        <!-- <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems"
          @click="genzongBtns"
          >客户跟踪</el-button
        >
        <el-button class="glo_btnItems" @click="guoZhang">过账</el-button>-->
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="jtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <queryBtns :MoreConditions="MoreConditions" @clerBtns="clerBtns" @queryBtn_ok="queryBtn_ok" @moreParam="moreParam"></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form :model="queryData" :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'" label-position="left">
        <!-- 时间组件 -->
        <el-form-item class="queryItemsTimes">
          <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time"></multitime>
        </el-form-item>
        <el-form-item class="queryItems" label="业务网点:">
          <el-select filterable clearable v-model="queryData.businessDeptId" placeholder="请输入" @change="queryBtn_ok">
            <el-option v-for="(item, index) in storageList" :key="index" :label="item.name" :value="item.documentId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="终端网点:">
          <el-select filterable clearable v-model="queryData.endDeptId" placeholder="请输入" @change="queryBtn_ok">
            <el-option v-for="item in storageList" :key="item.documentI" :label="item.name" :value="item.documentId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="送货方式:">
          <el-select filterable clearable v-model="queryData.sendMethodConfDictId" placeholder="请输入" @focus="getConfDictValDownList('send_method')">
            <el-option v-for="(item, index) in sendMethodList" :key="index" :label="item.key" :value="item.confDictId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="客户编号:">
          <el-select filterable clearable v-model="queryData.customerNumber" placeholder="请输入客户编号" remote :remote-method="getCustomerList" @change="changeCustomerNumber" @focus="getCustomerList()">
            <el-option v-for="(item, index) in CustomerLists" :key="index" :label="item.number + '(' + item.name + ')'" :value="item.number"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="运单号:">
          <el-input clearable v-model="queryData.waybillNumber" placeholder="请输入" @keyup.enter.native="queryBtn_ok"></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="客户单号:">
          <el-input clearable v-model="queryData.customereOrderNumber" placeholder="请输入" @keyup.enter.native="queryBtn_ok"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
        <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field == 'waybillNumber' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="left"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div class="linkTabel" @click.stop="$TOOLS.goYdDetails(scope.row)">{{ scope.row.waybillNumber }}</div>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="item.field == 'waybillStatusShow' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div style="color: #f00" v-if="scope.row.waybillStatus == 'yi_zuo_fei:waybill_status'">{{ scope.row.waybillStatusShow }}</div>
              <div v-else>{{ scope.row.waybillStatusShow }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="280px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button class="rbtns" @click.stop="ruKuConfirm(scope.row)">入库确认</el-button>
              <el-button class="rbtns" @click.stop="wtl_outStockSure(scope.row)">出库确认</el-button>
              <el-button class="rbtns" @click.stop="luRuFeiYong(scope.row)">装卸费录入</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 客户跟踪 -->
    <addCustomerTarck :showDia1="showDia1" :documentNumbers="documentNumbers" :documentStatus="documentStatus" :isdisabledStatus="true" @confirmAdd="confirmAdd" @closeDia1="closeDia1"></addCustomerTarck>

    <!-- 弹窗=>入库确认-->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn('dialogFormref')"
    >
      <div class="glo_dialogForm">
        <el-form v-if="isShowDialog" class="diaForm" ref="dialogFormref" :model="dialogForm" label-width="100px" :rules="rulesForm">
          <el-form-item class="dislogFormTextarea" prop="wayNumber" label="入库单号:">
            <el-input type="textarea" rows="2" v-model="dialogForm.wayNumber"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="inStockDeptId" label="入库部门:" style="width: 100%; margin-right: 0">
            <el-select style="width: 100%" v-model="dialogForm.inStockDeptId" placeholder="请选择" clearable filterable>
              <el-option v-for="item in storageList" :key="item.documentI" :label="item.name" :value="item.documentId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="comment" label="入库备注:">
            <el-input type="textarea" rows="2" v-model="dialogForm.comment"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 弹窗=>出库确认-->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="handleCloseDia2"
      @diaConfirmBtn="diaConfirmBtn2('dialogFormref2')"
    >
      <div class="glo_dialogForm">
        <el-form v-if="isShowDialog2" class="diaForm" ref="dialogFormref2" :model="dialogForm2" label-width="100px" :rules="rulesForm2">
          <el-form-item class="dialogFormItems" prop="wayNumber" label="运单号:">
            <el-input v-model="dialogForm2.wayNumber" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="outStockDeptId" label="出库部门:">
            <el-select style="width: 100%" v-model="dialogForm2.outStockDeptId" placeholder="请选择" clearable filterable>
              <el-option v-for="item in storageList" :key="item.documentI" :label="item.name" :value="item.documentId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="descStorageId" label="出库目的部门:">
            <el-select style="width: 100%" v-model="dialogForm2.descStorageId" placeholder="请选择" clearable filterable>
              <el-option v-for="item in storageList" :key="item.documentId" :label="item.name" :value="item.documentId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="comment" label="出库备注:">
            <el-input type="textarea" rows="2" v-model="dialogForm2.comment"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 当前页面的查询条件 -->
      <div ref="queryForm">
        <el-form :model="queryData" class="glo_form hasMoreParam" label-position="left">
          <el-form-item class="queryItemsTimes">
            <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time"></multitime>
          </el-form-item>
          <el-form-item class="queryItems" label="业务网点:">
            <el-select filterable clearable v-model="queryData.businessDeptId" placeholder="请输入" @change="queryBtn_ok">
              <el-option v-for="(item, index) in storageList" :key="index" :label="item.name" :value="item.documentId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="queryItems" label="终端网点:">
            <el-select filterable clearable v-model="queryData.endDeptId" placeholder="请输入" @change="queryBtn_ok">
              <el-option v-for="item in storageList" :key="item.documentI" :label="item.name" :value="item.documentId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="queryItems" label="送货方式:">
            <el-select filterable clearable v-model="queryData.sendMethodConfDictId" placeholder="请输入" @focus="getConfDictValDownList('send_method')">
              <el-option v-for="(item, index) in sendMethodList" :key="index" :label="item.key" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="queryItems" label="客户编号:">
            <el-select filterable clearable v-model="queryData.customerNumber" placeholder="请输入客户编号" remote :remote-method="getCustomerList" @change="changeCustomerNumber" @focus="getCustomerList()">
              <el-option v-for="(item, index) in CustomerLists" :key="index" :label="item.number + '(' + item.name + ')'" :value="item.number"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="queryItems" label="运单号:">
            <el-input clearable v-model="queryData.waybillNumber" placeholder="请输入" @keyup.enter.native="queryBtn_ok"></el-input>
          </el-form-item>
          <el-form-item class="queryItems" label="客户单号:">
            <el-input clearable v-model="queryData.customereOrderNumber" placeholder="请输入" @keyup.enter.native="queryBtn_ok"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </exportCompoent>
  </div>
</template>
<script>
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import multitime from "@/components/multiTime.vue";
import myDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
import addCustomerTarck from "@/components/CustomerServiceTrackingNew.vue";
// import uploadimgs from "@/components/upLoadImgs.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    multitime,
    addCustomerTarck,
    myDialog,
    // uploadimgs,
    queryBtns,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "运单库存列表", //导出时默认文件名
        apiName: "/admin/v4/tms/waybill/getWaybillList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      //  -----  查询  ------
      queryData: {
        currentDeptId: "",
        customerNumber: "",
        customereOrderNumber: "",
        endBusinessTime: "",
        endCreateTime: "",
        fieldName: "",
        fieldVal: "",
        onwayStatus: "zai_ku:onway_status",
        outboundCarrierId: "",
        outgoingStatus: "",
        startBusinessTime: "",
        startCreateTime: "",
        waybillNumber: "",
        waybillStatus: "",
        carrierName: "", //
      }, //  表单查询数据
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "创建日期",
        },
        {
          value: "1",
          label: "业务日期",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",

      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据

      show_sortTableHeard: false, //显示表格设置弹窗

      // 默认表头
      tabelHeadeTitle: [
        {
          name: "客户编号",
          field: "customerNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "客户单号",
          field: "customereOrderNumber",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "180",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "原运单号",
          field: "mainWaybillNumber",
          width: "160",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "拆单状态",
          field: "splitOrderStatusShow",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运单状态",
          field: "waybillStatusShow",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "在途状态",
          field: "onwayStatusShow",
          width: "110",
          sort: 18,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提货状态",
          field: "takeStatusShow",
          width: "110",
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "存在未完成的仓配任务",
          field: "isHasTaskNoCompleteShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "最新运输任务状态",
          field: "taskStatusShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "外发状态",
          field: "outgoingStatusShow",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "当前网点",
          field: "currentDeptName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "业务员",
          field: "businessName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "付款方式",
          field: "settlementMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "是否开票",
          field: "isInvoiceShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "开票税点",
          field: "taxes",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "业务时间",
          field: "businessDate",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "终端网点",
          field: "endDeptName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "业务网点",
          field: "businessDeptName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "外发承运商",
          field: "outboundCarrierName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运输方式",
          field: "transportMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提货方式",
          field: "receiveMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "送货方式",
          field: "sendMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "回单方式",
          field: "rnRequireName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "回单份数",
          field: "rnRequireCount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "开单运费",
          field: "billingAmount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "收货省份",
          field: "receiveProvinceName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货城市",
          field: "receiveCityName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货区县",
          field: "receiveAreaName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货详细地址",
          field: "receiveAddress",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货单位",
          field: "receiveCompany",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货人",
          field: "receiveContacts",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货电话",
          field: "receivePhone",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货省份",
          field: "takeProvinceName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货城市",
          field: "takeCityName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货区县",
          field: "takeAreaName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货详细地址",
          field: "takeAddress",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提货地址数量",
          field: "takeAddressCount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货单位",
          field: "takeCompany",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货人",
          field: "takeContacts",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货电话",
          field: "takePhone",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "创建时间",
          field: "createTime",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "创建人",
          field: "createUserName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "订单号",
          field: "orderNumber",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      myTableHeard: [], //  我的表头
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      tableData: [], //  表格数据

      allCheck: false, //  全选
      sortName: "运单在途模板", //  排序名
      selectLength: 0, //  显示的长度

      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "WaybillInventory", //  页面标识

      // 新建客服跟踪
      showDia1: false,
      documentNumbers: "",
      documentStatus: "", //包裹单据

      fileNameLists: [], //上传组件的
      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "",
      diaWidth: "40%",
      dialogForm: {
        // 弹窗表单数据
        comment: "",
        dispatchIds: [],
        waybillSplitIds: [],
        inStockDeptId: "",
        wayNumber: "",
      },
      rulesForm: {
        inStockDeptId: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },

      isShowDialog2: false,
      dialogTitle2: "",
      diaWidth2: "40%",
      dialogForm2: {
        comment: "",
        descStorageId: "",
        outStockDeptId: "",
        wayNumber: "",
        dispatchIds: [],
        waybillSplitIds: [],
      },
      rulesForm2: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // ==== 弹窗组件属性 end ====

      rules: {
        aaa: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
      },

      CustomerLists: [],
      storageList: [],
      sendMethodList: [],
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle;
    if (this.originalTabelHeadeTitle.length === 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      );
    }
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;

    this.getData();
    //获取默认表头 页面有这四个字段 myTableHeard,sortName,tabelHeadeTitle,totalArr
    this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
  },
  activated() {
    // 每次进页面都会触发的写这里
    //计算获取表格高度
    // this.getData();
    this.$nextTick(() => {
      this.fetTableHeight();
    });
  },
  mounted() {
    this.getObjectUserDownList("storage"); // 网点列表
  },
  watch: {},
  methods: {
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(dictType) {
      this.$API
        .wtl_getConfDictValDownList({ dictType: dictType })
        .then((res) => {
          let arrs = res.data.result || [];
          if (dictType == "package_name") {
            // 包装
            this.packageNameList = arrs;
            this.goodsInfoList[0].itemReqs[0].packageNameList = arrs;
          }
          if (dictType == "waybill_type") {
            // 货物类型
            this.waybillTypeList = arrs;
          }
          if (dictType == "rn_order_require") {
            // 回单类型
            this.rnrderRequireList = arrs;
          }
          if (dictType == "send_method") {
            // 获取送货方式列表
            this.sendMethodList = arrs;
          }
          if (dictType == "receive_method") {
            // 获取提货方式列表
            this.ReceivingMethodList = arrs;
          }
          if (dictType == "transport_method") {
            // 获取运输方式列表
            this.transportModeList = arrs;
          }
          if (dictType == "object_status") {
            // 获取结算对象类型
            this.objectStatusList = arrs;
          }
          if (dictType == "settlement_method") {
            // 获取付款方式
            this.settlementMethodList = arrs;
          }
        });
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key) {
      this.$API
        .wtl_getObjectUserDownList({
          key: key,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          if (key == "employee") {
            this.EmployeeList = arrs;
          }
          if (key == "dept") {
            this.depList = arrs;
          }
          if (key == "storage") {
            this.storageList = arrs;
          }
        });
    },
    // 获取客户列表
    getCustomerList(number) {
      this.$API
        .wtl_getObjectUserDownList({
          key: "customer",
          name: "",
          number: number || "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerLists = res.data.result.data || [];
        });
    },
    // 选择客户触发
    changeCustomerNumber(e) {
      if (!e) {
        this.getCustomerList();
      }
      this.queryBtn_ok();
    },
    //  xxx
    chaiDan(a) {
      this.$router.push({
        path: "/WaybillManage/SplitOrder",
        query: {
          id: 1,
        },
      });
    },
    // 入库确认
    ruKuConfirm(row) {
      let nums = "";
      let ids = [];
      if (row) {
        nums = row.waybillNumber;
        ids.push(row.waybillSplitId);
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请选择需要入库确认的运单");
          return false;
        }

        this.selectTableData.forEach((item) => {
          nums += item.waybillNumber + " ,";
          ids.push(item.waybillSplitId);
        });
        if (nums.length > 0) {
          nums = nums.substring(0, nums.length - 1);
        }
      }
      this.dialogForm.wayNumber = nums;
      this.dialogForm.waybillSplitIds = ids;

      this.isShowDialog = true;
      this.dialogTitle = "入库确认";
    },
    // 出库确认
    wtl_outStockSure(row) {
      let nums = "";
      let ids = [];
      if (row) {
        nums = row.waybillNumber;
        ids.push(row.waybillSplitId);
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请选择需要入库确认的运单");
          return false;
        }

        this.selectTableData.forEach((item) => {
          nums += item.waybillNumber + " ,";
          ids.push(item.waybillSplitId);
        });
        if (nums.length > 0) {
          nums = nums.substring(0, nums.length - 1);
        }
      }
      this.dialogForm2.wayNumber = nums;
      this.dialogForm2.waybillSplitIds = ids;

      this.isShowDialog2 = true;
      this.dialogTitle2 = "出库确认";
    },

    // 装卸费录入
    luRuFeiYong(row) {
      if (row) {
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请至少选择一条运单进行签收");
          return false;
        }
      }
      this.$router.push({
        path: "/WarehouseManagement/loadeUnloadeOrderAdd",
        query: {
          id: "1",
        },
      });
    },
    // 过账
    // guoZhang() {
    //   this.$router.push({
    //     path: "/WaybillManage/Posting",
    //     query: {
    //       id: "1",
    //     },
    //   });
    // },

    // 终止运单
    stopYd() {},

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
      this.dialogForm = {
        comment: "",
        dispatchIds: [],
        waybillSplitIds: [],
        inStockDeptId: "",
        wayNumber: "",
      };
    },
    //  弹窗确认保存事件 (入库确认)
    diaConfirmBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            comment: this.dialogForm.comment || "",
            dispatchIds: this.dialogForm.dispatchIds || [],
            waybillSplitIds: this.dialogForm.waybillSplitIds || [],
            inStockDeptId: this.dialogForm.inStockDeptId || "",
          };
          this.$API.wtl_inStockSure(param).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
            this.isShowDialog = false;
          });
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },

    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia2() {
      this.isShowDialog2 = false;
    },
    //  弹窗确认保存事件 (出库确认)
    diaConfirmBtn2(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            comment: this.dialogForm2.comment || "",
            dispatchIds: this.dialogForm2.dispatchIds || [],
            waybillSplitIds: this.dialogForm2.waybillSplitIds || [],
            outStockDeptId: this.dialogForm2.outStockDeptId || "",
            descStorageId: this.dialogForm2.descStorageId || "",
          };
          this.$API.wtl_outStockSure(param).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
            this.isShowDialog2 = false;
          });
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn2() {
      this.isShowDialog2 = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 跳转运单详情
    // goYdDetails(row) {
    //   // this.$message.success("你点我干嘛");
    //   this.$router.push({
    //     path: "/WaybillManage/WaybillDetails",
    //     query: {
    //       waybillSplitId: row.waybillSplitId,
    //       waybillNumber: row.waybillNumber,
    //     },
    //   });
    // },

    // 时间组件 选择时间后触发
    queryBtn_time(s, e) {
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e) {
      this.timeType = type || "0";
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },

    // 提交新建客服跟踪
    confirmAdd(formName) {
      this.showDia1 = false;
      this.getData();
    },
    // 关闭客户跟踪弹窗,重置弹窗数据
    closeDia1(e) {
      this.showDia1 = e || false;
      this.documentNumbers = ""; //如果不重置这个,第二次点开同样的数据组件不会监听到变化默认是空的
    },
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    rowclick2(row, event, column) {
      this.$refs.memberTable.toggleRowSelection(row);
    },

    getData() {
      let startBusinessTime = "";
      let endBusinessTime = "";
      let startCreateTime = "";
      let endCreateTime = "";

      let startTime = this.startTime_a ? this.startTime_a + " 00:00:00" : "";
      let endTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";

      if (this.timeType == "0") {
        startCreateTime = startTime;
        endCreateTime = endTime;
      }
      if (this.timeType == "1") {
        startBusinessTime = startTime;
        endBusinessTime = endTime;
      }

      let param = {
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
        currentDeptId: this.queryData.currentDeptId,
        customerNumber: this.queryData.customerNumber,
        customereOrderNumber: this.queryData.customereOrderNumber,
        startBusinessTime: startBusinessTime,
        endBusinessTime: endBusinessTime,
        startCreateTime: startCreateTime,
        endCreateTime: endCreateTime,
        fieldName: this.queryData.fieldName,
        fieldVal: this.queryData.fieldVal,
        onwayStatus: this.queryData.onwayStatus,
        outboundCarrierId: this.queryData.outboundCarrierId,
        outgoingStatus: this.queryData.outgoingStatus,
        waybillNumber: this.queryData.waybillNumber,
        waybillStatus: this.queryData.waybillStatus,
        endDeptId: this.queryData.endDeptId,
        businessDeptId: this.queryData.businessDeptId,
        sendMethodConfDictId: this.queryData.sendMethodConfDictId,
      };

      this.$API.wtl_getWaybillList(param).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;

          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },

    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      this.getData();
    },

    clerBtns() {
      //  重置按钮
      this.queryData = {
        currentDeptId: "",
        customerNumber: "",
        customereOrderNumber: "",
        endBusinessTime: "",
        endCreateTime: "",
        fieldName: "",
        fieldVal: "",
        onwayStatus: "zai_ku:onway_status",
        outboundCarrierId: "",
        outgoingStatus: "",
        startBusinessTime: "",
        startCreateTime: "",
        waybillNumber: "",
        waybillStatus: "",
        carrierName: "", //
      };
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    handleSizeChange(val) {
      //  分页
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //  分页
      this.pageStart = val;
      this.getData();
    },

    AddPackage() {
      //  添加包裹
      this.$router.push({
        path: "/BusinessManagement/addPacks",
      });
    },

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    ModifyPackage() {
      //  修改包裹
      if (this.selectTableData.length === 1) {
        this.$router.push({
          path: "/BusinessManagement/addPacks",
          query: {
            packageId: this.selectTableData[0].packageId,
          },
        });
      } else {
        this.$message.error("请选一个需要修改的包裹");
      }
    },

    PackageDetails() {
      //  包裹详情
      if (this.selectTableData.length > 0) {
        this.$router.push({
          path: "/BusinessManagement/packsDetails",
          query: {
            packageId: this.selectTableData[0].packageId,
            courierNumber: this.selectTableData[0].courierNumber,
          },
        });
      } else {
        this.$router.push({
          path: "/BusinessManagement/packsDetails",
        });
      }
    },
    dabaoDetails() {
      //  包裹详情
      if (this.selectTableData.length === 1) {
        if (
          this.selectTableData[0].packageStatus ==
            "chu_ku_zai_tu:package_status" ||
          this.selectTableData[0].packageStatus ==
            "ke_hu_qian_shou:package_status" ||
          this.selectTableData[0].packageStatus ==
            "chu_ku_zhong:package_status" ||
          this.selectTableData[0].packageStatus ==
            "da_bao_wan_cheng:package_status"
        ) {
          this.$router.push({
            path: "/BusinessManagement/dabaoDetails",
            query: {
              packageId: this.selectTableData[0].packageId,
            },
          });
        } else {
          this.$message.error("包裹未打包完成");
        }
      } else {
        this.$message.error("请选择一个包裹");
      }
    },

    // genzongBtns() {
    //   let str = "";
    //   console.log(this.selectTableData);
    //   this.selectTableData.forEach((item) => {
    //     str += item.courierNumber + ",";
    //   });
    //   if (str.length > 0) {
    //     str = str.substring(0, str.length - 1);
    //   }
    //   this.documentNumbers = str;
    //   this.documentStatus = "package_v1:document_status"; //包裹单据
    //   this.showDia1 = true;
    // },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.$refs.mytable.doLayout();
      });
    },

    /****
     *  ===================下面页面公共方法 start ===================
     *
     */

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dyyd") {
        // 打印运单
      }
      if (a === "dybq") {
        // 打印标签
      }
      if (a === "dr") {
        // 导入
      }
      if (a === "jtdc") {
        // 导出
        // this.exportBtn();
        this.isShowDialog_dc = true;
      }
    },

    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },

    // ===================排序表头彈窗的组件方法 start ===================
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitle = e;
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let param = {
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
      };
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        //获取默认表头
        this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e;
    },

    /****
     *  ===================排序表头彈窗的组件方法 end ===================
     *
     */
  },
};
</script>
<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}
</style>
